import { HighPrioritySchoolIndicator } from '@/components/high-priority-school-indicator.js';
import { Link } from '@tanstack/react-router';

interface LearningIssueSchoolCellProps {
  schoolId: string;
  label: string;
  isHighPriority?: boolean | null;
  studentId: string;
}

export function LearningIssueSchoolCell({ schoolId, label, isHighPriority, studentId }: LearningIssueSchoolCellProps) {
  return (
    <span className="inline-flex items-center gap-1">
      <Link to={'/orgs/schools/$schoolId/schedules'} params={{ schoolId }} className="text-blue-600">
        {label}
      </Link>
      <HighPrioritySchoolIndicator
        isHighPriority={isHighPriority}
        data-testid={`students-learning-issue-table-icon-high-priority-school-${studentId}`}
      />
    </span>
  );
}
